const getSubscriptionProduct = (subscription = {}) => {
  if (!subscription) {
    return null;
  }

  return subscription?.items?.[0]?.price?.product || null;
};

export default getSubscriptionProduct;
